define 'controller/AddToBasketController', ['jquery', 'lib/product-reviews', 'lib/kryptonite', 'lib/slick' ], ($, reviews ) ->
  class AddToBasketController

    constructor: (@$el) ->
      self = this

      @$el.on 'click', '[data-add-to-basket]', { self: self }, self._onShowAddToBasketLayer
      @$el.on 'click', '[add-to-basket-picture]', { self: self }, self._onShowAddToBasketLayer

    _onShowAddToBasketLayer: (event) ->
      console.log("Add to basket")
      event.stopPropagation()
      event.preventDefault()

      event.data.self
      element = event.currentTarget
      productId = element.dataset.addToBasket
      catId = element.dataset.category
      template = element.dataset.template
      ref = element.dataset.ref
      trackingToken = element.dataset.trackingToken

      $('#modalOverlay').data 'template', template
      console.log("TRACKING TOKEN: ", trackingToken)
      if (trackingToken)
        trackingData = productId.substring(0,6).concat("&trackingToken=",encodeURIComponent(trackingToken))
        $.ajax
          url: "/api/gk/click/product?pid="+ trackingData
          type: 'POST'
          xhrFields:
            showLoadingIndicator: false
          success: (content) ->
            if content == undefined
              console.log("success result: ", content)
      $.ajax
        url: '/api/datalayer/event/addToBasketClickEvent?externalKey=' + productId + '&ref='+ref + '&template='+template
        type: 'GET'
        xhrFields:
          showLoadingIndicator: false
        success: (content) ->
          if content == undefined
            return
          datalayerEvent = ""
          try
            datalayerEvent = JSON.parse(decodeURIComponent(escape(atob(content))))
          catch e
            datalayerEvent = JSON.parse(atob(content))
          $.ajax
            url: '/api/datalayer/event/avisData?externalKey=' + productId
            type: 'GET'
            xhrFields:
              showLoadingIndicator: false
            success: (data) ->
              siteId = data.siteId
              productKeys = data.concatenatedArticleRefs.split(',')
              reviews.retrieveRating siteId, productKeys, (rating) ->
                datalayerEvent.siteId = siteId
                datalayerEvent.avisRating = rating
                if event
                  dataLayer.push(datalayerEvent)
            error : ->
              if productId
                dataLayer.push(datalayerEvent)

      $.kryptonite
        url: '/add-to-basket'
        method: 'GET'
        data:
          'productId': productId
          'template': template
          'catId': catId
          'ref' : ref
